import { Component, OnInit } from '@angular/core';
import { IMAGES } from 'src/app/constants/imagePath';
import { SeoService } from 'src/app/service/seo.service';

@Component({
  selector: 'app-leaderboard',
  templateUrl: './leaderboard.component.html',
  styleUrls: ['./leaderboard.component.scss'],
  standalone: false
})
export class LeaderboardComponent implements OnInit {
  Images = IMAGES;

  constructor(private seoService: SeoService) {}

  leaders = [
    { img: IMAGES.CHAIRMAN, name: 'Vinish Kathuria', role: 'Chairman', linkedin: 'https://www.linkedin.com/in/vinkats/' },
    { img: IMAGES.BM1, name: 'Arjun Jain', role: 'Board Member', linkedin: 'https://www.linkedin.com/in/arjun-jain-999410a6/' },
    { img: IMAGES.BM2, name: 'K Mahendra Kumar', role: 'Board Member', linkedin: 'https://www.linkedin.com/in/kmahendrak/' },
    { img: IMAGES.CEO, name: 'Dixit Roy Mahidhara', role: 'CEO', linkedin: 'https://www.linkedin.com/in/dmahidhara/' },
    { img: IMAGES.CTO, name: 'Siji Sunny', role: 'CTO', linkedin: 'https://www.linkedin.com/in/sijisunny/' },
  ];


  ngOnInit() {
    window.scrollTo({ top: 0, behavior: 'smooth' });

    this.seoService.addJsonLdSchema({
      '@context': 'https://schema.org',
      '@type': 'Organization',
      'name': 'Varroc Connect Leadership Team',
      'url': 'https://varrocconnect.com/leadership',
      'logo': 'https://varrocconnect.com/assets/images/websitev2/varroc-connect-logo.png',
      'description': 'Meet the Varroc Connect leadership team driving innovation and excellence in automotive solutions. Discover their vision, expertise, and commitment.',
      'sameAs': [
        'https://www.linkedin.com/company/varrocconnect/'
      ],
      'employee': [
        {
          '@type': 'Person',
          'name': 'Vinish Kathuria',
          'jobTitle': 'Chairman',
          'worksFor': {
            '@type': 'Organization',
            'name': 'Varroc Connect'
          },
          'sameAs': [
            'https://www.linkedin.com/in/vinkats/'
          ]
        },
        {
          '@type': 'Person',
          'name': 'Arjun Jain',
          'jobTitle': 'Board Member',
          'worksFor': {
            '@type': 'Organization',
            'name': 'Varroc Connect'
          },
          'sameAs': [
            'https://www.linkedin.com/in/arjun-jain-999410a6/'
          ]
        },
        {
          '@type': 'Person',
          'name': 'K Mahendra Kumar',
          'jobTitle': 'Board Member',
          'worksFor': {
            '@type': 'Organization',
            'name': 'Varroc Connect'
          },
          'sameAs': [
            'https://www.linkedin.com/in/kmahendrak/'
          ]
        },
        {
          '@type': 'Person',
          'name': 'Dixit Roy Mahidhara',
          'jobTitle': 'CEO',
          'worksFor': {
            '@type': 'Organization',
            'name': 'Varroc Connect'
          },
          'sameAs': [
            'https://www.linkedin.com/in/dmahidhara/'
          ]
        },
        {
          '@type': 'Person',
          'name': 'Siji Sunny',
          'jobTitle': 'CTO',
          'worksFor': {
            '@type': 'Organization',
            'name': 'Varroc Connect'
          },
          'sameAs': [
            'https://www.linkedin.com/in/sijisunny/'
          ]
        }
      ]
    }, 'jsonld-organization');
  }

}
